module.exports = __webpack_public_path__ + "img/TSY_02_01.841ab274.png";